import PawLoader from 'components/paw-loader';
import { useAuth } from 'contexts/auth';
import Router from 'next/router';
import React from 'react';

interface FallbackPath {
  url: string;
  as?: string;
}

interface PropTypes {
  fallbackPath?: FallbackPath;
}

const defaultFallbackPath = {
  url: '/login',
};

const Restricted: React.FC<React.PropsWithChildren<PropTypes>> = ({
  fallbackPath = defaultFallbackPath,
  children,
}) => {
  const { isUserAuthenticated, isGuest, loading } = useAuth();
  const $pushed = React.useRef(false);

  const shouldUseFallback = React.useMemo(() => {
    return !isUserAuthenticated || isGuest;
  }, [isUserAuthenticated, isGuest]);

  React.useEffect(() => {
    if (!loading && shouldUseFallback && !$pushed.current) {
      $pushed.current = true;
      Router.replace(`${fallbackPath.url}?redirectUrl=${encodeURIComponent(Router.asPath)}`);
    }
  }, [fallbackPath.url, isGuest, isUserAuthenticated, loading, shouldUseFallback]);

  if (loading !== false) {
    return (
      <div className="flex h-105 w-full items-center justify-center">
        <PawLoader />
      </div>
    );
  }

  if (shouldUseFallback || typeof window === 'undefined') {
    return null;
  }

  return <>{children}</>;
};

export default Restricted;
